import { render, staticRenderFns } from "./leisureProducts.vue?vue&type=template&id=5d5bade2&scoped=true&"
import script from "./leisureProducts.vue?vue&type=script&lang=js&"
export * from "./leisureProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5bade2",
  null
  
)

export default component.exports